import { CLIENT_USER_ROLES } from '@data/users/model/user'

// Derived rather than duplicated: the API rejects any position outside `ClientUserRoles`
// with 422, so a hand-maintained copy of the list is a latent break. One already happened —
// the API corrected `Sectary` to `Secretary` and this list kept offering the old spelling.
export const ClientPositionOptions = CLIENT_USER_ROLES
